import "./savingAmountCard.scss";
import Typography from "../../../../../common/Typography";

const CustomerSavingAmountCard = ({ amount }) => {
  return (
    <div className="customer-saving-amount-card">
      <img
        alt="gradient_vector"
        className="gradient-vector-1"
        src="/assets/images/membership/gradient_vector.svg"
      />
      <img src="/assets/icons/party-popper.svg" alt="party-popper-icon" />
      <Typography size="display-md" weight="medium">
        You’ll potentially save <span>{amount}</span>
      </Typography>
      <img
        alt="gradient_vector"
        className="gradient-vector-2"
        src="/assets/images/membership/gradient_vector.svg"
      />
    </div>
  );
};

export default CustomerSavingAmountCard;
